import { queryOptions, useQuery } from '@tanstack/react-query';

import { notificationsApi } from '../api/notifications-api';

import { notificationKeys } from './notification-keys';

export function notificationTemplatesQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: notificationKeys.list(storeId),
    queryFn: () => notificationsApi.list(storeId),
  });
}

/** `enabled` false skips the request for members without `settings.read`. */
export function useNotificationTemplates(storeId: string, enabled = true) {
  return useQuery({ ...notificationTemplatesQueryOptions(storeId), enabled });
}
